"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_EXPORT_STATUS_WAITING = exports.DATA_EXPORT_STATUS_PROCESSING = exports.DATA_EXPORT_STATUS_FAILED = exports.DATA_EXPORT_STATUS_COMPLETED = exports.DATA_EXPORT_STATUS_CANCELLED = void 0;
exports.DATA_EXPORT_STATUS_CANCELLED = 'cancelled';
exports.DATA_EXPORT_STATUS_COMPLETED = 'completed';
exports.DATA_EXPORT_STATUS_FAILED = 'failed';
exports.DATA_EXPORT_STATUS_PROCESSING = 'processing';
exports.DATA_EXPORT_STATUS_WAITING = 'waiting';
//# sourceMappingURL=DataExport.js.map